import { useEffect, useEffectEvent } from 'react';
import { useQuery, skipToken } from '@apollo/client/react';
import { ErrorLike } from '@apollo/client';
import { DateTime } from 'luxon';

import { useApolloError } from 'common/hooks/useApolloError';
import {
    IOfferEventType,
    OfferEventsForCertificateDocument,
} from 'graphql/types';

interface IProps {
    certificateId: string;
    types: IOfferEventType[];
    fromDate?: DateTime;
    canEnrollParticipants?: boolean;
}

export const useOfferEventForCertificate = ({
    certificateId,
    types,
    fromDate,
    canEnrollParticipants,
}: IProps) => {
    const { showApolloError } = useApolloError();
    const { data, loading, error } = useQuery(
        OfferEventsForCertificateDocument,
        certificateId
            ? {
                  variables: {
                      certificateId,
                      types,
                      first: 3,
                      fromDate: fromDate?.toISODate(),
                      canEnrollParticipants,
                  },
                  notifyOnNetworkStatusChange: true,
              }
            : skipToken
    );

    const onError = useEffectEvent((error: ErrorLike) => {
        showApolloError(error);
    });

    useEffect(() => {
        if (error) {
            onError(error);
        }
    }, [error]);

    const { count, edges } = data?.paginatedOfferEvents || {};

    const offerEvents = edges?.map((edge) => edge?.node).filter(Boolean) || [];

    return { offerEvents, loading, count };
};
